<app-card-widget title="Financing Transfers" *ngIf="invoice$ | async">

  <mat-card *ngIf="holdRefusal" class="warning-card financing-hold-refusal">
    <mat-card-content>
      <mat-icon color="warn">block</mat-icon>
      {{ holdRefusal.lead }}: the invoice is on financing hold.
      <ul class="financing-hold-list">
        <li *ngFor="let hold of holdRefusal.holds">{{ describeHold(hold) }}</li>
      </ul>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="refusal" class="warning-card payment-refusal">
    <mat-card-content>
      <mat-icon color="warn">block</mat-icon>
      {{ refusal.lead }}: {{ refusal.message }}
    </mat-card-content>
  </mat-card>

  <form [formGroup]="form" id="outgoing-payment-form" (ngSubmit)="save()" *ngIf="lookups$ | async as lookups" novalidate>

    <div class="card-section-container">

      <div class="card-section">

        <mat-nav-list>
          <mat-list-item class="payment-list-item" *ngFor="let item of outgoingPayments$ | async" (click)="itemClicked(item)" [class.mat-elevation-z2]="item === selectedItem" [ngClass]="getStatusClass(item.status)">
            <div class="payment-item-container" fxLayout="column">
              <div class="payment-row-container" fxLayout="row" fxLayoutAlign="space-between start">
                <div class="payment-details" fxLayout="column">
                  <div class="payment-line amount-line">
                    <span class="amount">{{ item.amount.amount | currency:'EUR' }}</span>
                  </div>
                  <div class="payment-line recipient-line">
                    <span>{{ item.to_iban | ibanFormatter }}</span>
                    <span *ngIf="item.to_bic"> - {{ item.to_bic }}</span>
                  </div>
                  <div class="payment-line secondary-line" *ngIf="item.reference_text || item.reference_number">
                    <span>{{ item.reference_text }}</span>
                    <span *ngIf="item.reference_text && item.reference_number"> / </span>
                    <span>{{ item.reference_number }}</span>
                  </div>
                </div>
                <div class="payment-status" fxLayout="column" fxLayoutAlign="start end">
                  <div class="channel-info">{{ item.is_legacy ? item.legacy_payment_channel : item.provider_key }}</div>
                  <div class="timestamp">{{ item.created_at | date:'short' }}</div>
                  <div *ngIf="item.is_legacy" class="legacy-indicator">legacy</div>
                  <div class="actions-container">
                    <div *ngIf="!item.is_legacy" class="action-buttons" fxLayout="row" fxLayoutGap="8px">
                      <button type="button" mat-stroked-button color="primary" *ngIf="item.is_resubmittable && (canResubmitPayment$ | async)" (click)="resubmitPayment(item, $event)">Resubmit</button>
                      <button type="button" mat-stroked-button color="primary" *ngIf="item.is_retryable && (canRetryPayment$ | async)" (click)="retryPayment(item, $event)">Retry</button>
                      <button type="button" mat-stroked-button color="warn" *ngIf="item.is_cancellable && (canCancelPayment$ | async)" (click)="cancelPayment(item, $event)">Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="status-row" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                <app-outgoing-payment-status-label [status]="item.status" [state]="item.state" [statusReason]="item.status_reason"></app-outgoing-payment-status-label>
                <span *ngIf="item.is_express" class="express-badge">Express</span>
              </div>
            </div>
          </mat-list-item>
        </mat-nav-list>

      </div>

      <div class="card-section" *ngIf="selectedItem || added">

        <app-text label="Status" *ngIf="!added">{{ selectedItem.status || 'Unknown' }}</app-text>
        <app-text label="Status Reason" *ngIf="!added && selectedItem.status_reason">{{ selectedItem.status_reason }}</app-text>

        <ng-container *ngIf="!added">
          <app-text label="Channel" *ngIf="selectedItem.is_legacy">{{ selectedItem.legacy_payment_channel }}</app-text>
          <app-text label="Channel" *ngIf="!selectedItem.is_legacy">{{ selectedItem.provider_key }}</app-text>
        </ng-container>

        <mat-form-field *ngIf="added">
          <mat-select placeholder="Channel" formControlName="channelId">
            <mat-option *ngFor="let choice of lookups.bankServiceConnections" [value]="choice.provider_key">
              {{choice.display_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <ng-container *ngIf="!added">
          <app-text label="Reason" *ngIf="selectedItem.is_legacy">{{ selectedItem.legacy_payment_reason }}</app-text>
          <app-text label="Reason" *ngIf="!selectedItem.is_legacy">{{ selectedItem.reason_key }}</app-text>
        </ng-container>

        <mat-form-field *ngIf="added">
          <mat-select placeholder="Reason" formControlName="reasonId">
            <mat-option *ngFor="let choice of lookups.outgoingPaymentReasons" [value]="choice.reason_key">
              {{choice.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Express" *ngIf="!added">{{ selectedItem.is_express ? 'yes' : 'no' }}</app-text>

        <mat-checkbox *ngIf="added && form.get('reasonId').value === 'INVOICE_FINANCING'" formControlName="is_express">Express payment</mat-checkbox>

        <mat-card *ngIf="added && financingHoldBlocksPayment" class="warning-card financing-hold-warning">
          <mat-card-content>
            <mat-icon color="warn">warning</mat-icon>
            The invoice is on financing hold, so no financing or final payment can be made until the hold is released:
            <ul class="financing-hold-list">
              <li *ngFor="let hold of invoice.financing_holds">{{ describeHold(hold) }}</li>
            </ul>
          </mat-card-content>
        </mat-card>

        <app-text label="Reference Text" *ngIf="!added">{{selectedItem.reference_text}}</app-text>

        <mat-form-field *ngIf="added">
          <input matInput type="text" placeholder="Reference Text" formControlName="referenceText"/>
        </mat-form-field>

        <app-text label="Reference Number" *ngIf="!added && selectedItem.reference_number">{{selectedItem.reference_number}}</app-text>

        <mat-form-field *ngIf="added">
          <input matInput type="text" placeholder="Reference Number" formControlName="referenceNumber"/>
        </mat-form-field>


        <app-text label="To IBAN" *ngIf="!added">{{selectedItem.to_iban | ibanFormatter}}</app-text>

        <mat-form-field *ngIf="added">
          <input matInput type="text" placeholder="To IBAN" formControlName="toBankAccount"/>
          <mat-icon *ngIf="toIbanStatus === 'verified'" matSuffix class="icon-verified" matTooltip="IBAN is a client bank account with ownership confirmed.">check_circle</mat-icon>
          <mat-icon *ngIf="toIbanStatus === 'unverified'" matSuffix class="icon-unverified" matTooltip="IBAN is a client bank account, but its ownership is not confirmed.">warning</mat-icon>
          <mat-icon *ngIf="toIbanStatus === 'unknown'" matSuffix class="icon-unknown" matTooltip="IBAN is not a client bank account.">error</mat-icon>
        </mat-form-field>

        <mat-card *ngIf="added && noVerifiedAccount" class="warning-card">
          <mat-card-content>
            <mat-icon color="warn">warning</mat-icon>
            No ownership-confirmed bank account for this client. Please confirm the ownership of a bank account before creating a financing payment.
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="added && invoiceIbanMismatch" class="warning-card">
          <mat-card-content>
            <mat-icon color="warn">warning</mat-icon>
            The invoice IBAN does not match the client's ownership-confirmed bank account. Please resolve this inconsistency before proceeding.
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="added && unknownLEService" class="warning-card">
          <mat-card-content>
            <mat-icon color="warn">warning</mat-icon>
            Unknown invoicing service for this Light Entrepreneur client. Cannot create a financing payment.
          </mat-card-content>
        </mat-card>

        <!-- Verification of Payee: the bank's check of the recipient's IBAN against its name. -->
        <div *ngIf="added && vop.kind !== 'idle'" class="vop-state" [ngSwitch]="vop.kind">
          <div *ngSwitchCase="'waiting'" class="vop-waiting">
            <mat-icon>hourglass_empty</mat-icon>
            Checking the payee at the bank&hellip; This can take up to a minute.<span *ngIf="vopWaitIsOptional"> You can transfer without waiting.</span>
          </div>
          <div *ngSwitchCase="'in_progress'" class="vop-in-progress">
            <mat-icon color="warn">schedule</mat-icon>
            Verification of Payee is still in progress. Try again later.
            <button type="button" mat-button class="vop-check-again" (click)="checkPayeeAgain()">Check again</button>
          </div>
          <div *ngSwitchCase="'error'" class="vop-error">
            <mat-icon color="warn">error</mat-icon>
            Verification of Payee could not be asked.
            <button type="button" mat-button class="vop-check-again" (click)="checkPayeeAgain()">Check again</button>
          </div>
          <ng-container *ngSwitchCase="'result'">
            <ng-container *ngIf="vop.kind === 'result'">
              <div class="vop-result" [ngClass]="'vop-' + vop.result.outcome">
                Verification of Payee: {{ vopResultLabel(vop.result) }}<span *ngIf="vopHolderName(vop.result) as holder" class="vop-holder">: the account holder is {{ holder }}</span><span *ngIf="vop.result.outcome === 'rejected'">: the bank refused to check the IBAN and name<span *ngIf="vop.result.reason"> ({{ vop.result.reason }})</span>.</span>
              </div>
              <div *ngIf="vop.result.outcome === 'not_possible' && vop.result.reason" class="vop-reason">
                Reason: {{ vop.result.reason }}
              </div>
              <mat-card *ngIf="vop.result.outcome === 'rejected'" class="warning-card vop-rejected-error">
                <mat-card-content>
                  <mat-icon color="warn">error</mat-icon>
                  Fix the IBAN or the name and check again. Only if the payout must go out as it is, make a VoP override with a reason.
                </mat-card-content>
              </mat-card>
              <mat-card *ngIf="vop.result.outcome === 'no_match'" class="warning-card vop-no-match-warning">
                <mat-card-content>
                  <mat-icon color="warn">report</mat-icon>
                  The bank says this name is not the holder of this account. The money may go to someone else, and once sent it cannot be recovered.
                </mat-card-content>
              </mat-card>
              <div *ngIf="vopOverrideOffered" class="vop-override">
                <mat-checkbox formControlName="vop_override">Make a VoP override: pay although the VoP result is not a match</mat-checkbox>
                <mat-form-field *ngIf="vopOverrideNeedsReason" class="vop-override-reason">
                  <textarea matInput placeholder="Reason for the VoP override (required)" formControlName="vop_override_reason"></textarea>
                </mat-form-field>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <app-text label="To BIC" *ngIf="!added">{{selectedItem.to_bic}}</app-text>

        <mat-form-field *ngIf="added">
          <input matInput type="text" placeholder="To BIC" formControlName="toBic"/>
        </mat-form-field>

        <!-- AI: Added recipient details -->
        <app-text label="To Name" *ngIf="!added">{{selectedItem.to_name}}</app-text>
        <mat-form-field *ngIf="added">
          <input matInput type="text" placeholder="To Name" formControlName="to_name"/>
        </mat-form-field>

        <app-text label="To Country" *ngIf="!added">{{selectedItem.to_country}}</app-text>
        <mat-form-field *ngIf="added">
          <input matInput type="text" placeholder="To Country" formControlName="to_country"/>
        </mat-form-field>

        <!-- AI: Optional recipient address details are shown here in view mode, and are editable under advanced options -->
        <app-text label="To Street Address" *ngIf="!added">{{selectedItem.to_street_address}}</app-text>
        <app-text label="To City" *ngIf="!added">{{selectedItem.to_city}}</app-text>
        <app-text label="To Postal Code" *ngIf="!added">{{selectedItem.to_postal_code}}</app-text>
        <app-text label="To Business ID" *ngIf="!added">{{selectedItem.to_business_id}}</app-text>

        <app-text label="Amount" *ngIf="!added">{{selectedItem.amount.amount | currency:'EUR'}}</app-text>

        <mat-form-field *ngIf="added">
          <input matInput type="number" placeholder="Amount" formControlName="amount"/>
        </mat-form-field>

        <div *ngIf="added" class="advanced-options-container">
          <!-- Keyboard-operable in place: Enter and Space do what a click does, and Space must not also scroll the page. -->
          <a class="advanced-options-toggle"
             role="button"
             tabindex="0"
             (click)="toggleAdvancedOptions()"
             (keydown.enter)="toggleAdvancedOptions()"
             (keydown.space)="$event.preventDefault(); toggleAdvancedOptions()">
            {{ showAdvancedOptions ? 'Hide' : 'Show' }} advanced options
          </a>

          <div class="advanced-options-fields" *ngIf="showAdvancedOptions">
            <mat-form-field>
              <input matInput type="text" placeholder="To Street Address" formControlName="to_street_address"/>
            </mat-form-field>

            <mat-form-field>
              <input matInput type="text" placeholder="To City" formControlName="to_city"/>
            </mat-form-field>

            <mat-form-field>
              <input matInput type="text" placeholder="To Postal Code" formControlName="to_postal_code"/>
            </mat-form-field>

            <mat-form-field>
              <input matInput type="text" placeholder="To Business ID" formControlName="to_business_id"/>
            </mat-form-field>

            <mat-form-field>
              <input matInput type="number" placeholder="Sequence" formControlName="sequence"/>
              <mat-hint>Used to allow intentionally duplicate payments.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <app-text label="User" *ngIf="!added && selectedItem.created_by">{{selectedItem.created_by.name}}</app-text>

        <app-text label="Created" *ngIf="!added">{{selectedItem.created_at | date:'medium'}}</app-text>

      </div>

    </div>

  </form>

  <mat-card-actions align="end" *ngIf="canCreatePayment$ | async">
    <button type="button" mat-button *ngIf="!added && !added" [disabled]="locked" (click)="add()">Add</button>
    <button type="submit" mat-button *ngIf="added" [disabled]="!form.valid || saving || noVerifiedAccount || invoiceIbanMismatch || unknownLEService || financingHoldBlocksPayment || vopBlocksPayment" form="outgoing-payment-form">Transfer</button>
    <button type="reset" mat-button *ngIf="added" (click)="revert()">Cancel</button>
  </mat-card-actions>

</app-card-widget>
